export default __webpack_public_path__ + "static/circle_w.90c9f53da08e733662691cbff75d2906.png";